<template>
  <!-- 充值确认信息弹窗 -->
  <custom-dialog
    v-if="dialogVisible"
    width="1400px"
    top="6vh"
    :visible="dialogVisible"
    title="余额变更记录"
    @close="dialogVisible = false"
  >
    <div slot="content">
      <!-- 会员列表 -->
      <div class="member-info">
        <div class="member-info-title">
          <span><i class="el-icon-user-solid"></i></span>
          <span>{{ walletInfo.memberName }}</span>
          <span>{{ walletInfo.phone }}</span>
        </div>
        <div class="member-info-amt">
          <div class="member-info-amt-item">
            <span>当前余额</span>
            <span class="amt current-amt">￥{{ walletInfo.curAmount }}</span>
          </div>
          <div class="member-info-amt-item">
            <span>累计充值</span>
            <span class="amt">￥{{ walletInfo.rechargeAmount }}</span>
          </div>
        </div>
      </div>
      <el-table v-loading="loading" :data="tableData" :max-height="tableHeight" border>
        <el-table-column prop="time" label="交易时间" min-width="160" />
        <el-table-column prop="payPalNumber" label="流水号" min-width="160" />
        <el-table-column prop="phone" label="交易类型" min-width="100">
          <template slot-scope="scope">
            <div class="type" :class="('type' + scope.row.walletTradeType)">{{ scope.row.walletTradeTypeText || '' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="walletTradeMethod" label="交易方式" min-width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.walletTradeMethod == 3">好码齐</div>
            <div v-if="scope.row.walletTradeMethod == 2">现金</div>
            <div v-if="scope.row.walletTradeMethod == 11">财务转账</div>
          </template>
        </el-table-column>
        <el-table-column prop="tradeAmount" label="交易金额(元)" min-width="110" align="right">
          <template slot-scope="scope">
            <div class="amt" :style="{ color: scope.row.refundSuccess == '0' ? '#F54A45' : '#000' }">{{ scope.row.tradeAmount }}</div>
            <div class="amt_fail" v-if="scope.row.refundSuccess == '0'">退费失败</div>
          </template>
        </el-table-column>
        <el-table-column prop="afterAmount" label="余额(元)" min-width="90" align="right">
          <template slot-scope="scope">
            <div class="amt">{{ scope.row.afterAmount }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="patientName" label="患者姓名" min-width="110" />
        <el-table-column prop="deptName" label="销售门店" min-width="100" />
        <el-table-column prop="salesPerson" label="销售人员 " min-width="110" />
        <el-table-column prop="opt" label="收费员" min-width="100" />
        <el-table-column label="操作" min-width="200" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="[1, 4].includes(scope.row.walletTradeType)" size="medium" @click="printHandle(scope.row)">打印凭证</el-button>
            <el-button v-if="scope.row.refundSuccess == '0'" size="medium" @click="refund(scope.row)">重新退费</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination" style="text-align: right;">
        <el-pagination
          class="mt20"
          :total="pageInfo.total"
          :current-page="pageInfo.pageNum"
          :page-size="pageInfo.pageSize"
          layout="total, prev, pager, next"
          @current-change="changePageHandle"
        />
      </div>
    </div>
    <div slot="footer"></div>
  </custom-dialog>
</template>
 
<script>
  import req from '@/utils/request'
  export default {
    data() {
      return {
        loading: false,
        pageInfo: {
          pageNum: 1, // 当前页
          pageSize: 10, // 显示条数
          total: 0, // 总条数
        },
        walletInfo: {}, // 钱包信息
        tableData: [], // 会员列表
        tableHeight: 0, // 表格最大高度
      }
    },
    methods: {
     async refund(row){
        this.loading = true
        const { code, data } = await req.post('/member/wallet/recharge/retryRechargeRefund', {rechargeNumber:row.billNumber})
        if(code === 200){
          if(data && data.result){
            setTimeout(() => {
              this.$message.success('操作成功')
              this.getTableData()
              this.loading = false
            }, 3 * 1000);
          }else{
            this.$message.error(data.message);
            this.loading = false
          }
        }else{
          this.loading = false
        }
        
      },  
      async getTableData(init = 0) {
        if (init === 1) this.pageInfo.pageNum = 1
        const params = {
          memberId: this.memberInfo.memberId,
          pageIndex: this.pageInfo.pageNum, // 当前页
          pageSize: this.pageInfo.pageSize, // 每页条数
        }
        this.loading = true
        const { code, data } = await req.get('/member/wallet/detail', params)
        this.loading = false
        if (code === 200) {
          const walletTradeTypeInfo = {
            '-1': '管理员扣款',
            '1': '充值',
            '2': '消费',
            '3': '消费退费',
            '4': '充值退费'
          }
          this.walletInfo = {
            memberName: data.memberName || '',
            phone: data.phone || '',
            curAmount: data.curAmount,  // 当前余额
            rechargeAmount: data.rechargeAmount // 累计充值金额
          }

          this.pageInfo.total = (data.walletBills || {}).totalNum || 0
          this.tableData = ((data.walletBills || {}).items || []).map(item => ({
            ...item,
            walletTradeTypeText: item.walletTradeType ? (walletTradeTypeInfo[item.walletTradeType] || '') : ''
          }))
        }
      },

      // 改变页码
      changePageHandle(page) {
        this.pageInfo.pageNum = page
        this.getTableData()
      },

      // 打印
      async printHandle(itemInfo) {
        const params = {
          id: itemInfo.billNumber,
          deptId: this.$session.get('deptId'),
          printType: '1',
          orderType: itemInfo.walletTradeType === 1 ? '17' : '18',  // 1:充值  4:充值退费
        }
        const { code } = await req.post('/cloudprint/printOrder', params)
        if (code === 200) {
          this.$message.success('打印成功')
        }
      }
    },
    created() {
      if (document.documentElement.clientWidth > 1250) this.tableHeight = document.documentElement.clientHeight - 400
      else this.tableHeight = document.documentElement.clientHeight - 360
    },
    mounted() {
 
    },
    props: {
      value: {
        type: Boolean,
        default: false
      },
      memberInfo: {
        type: Object,
        default: () => {}
      }
    },
    computed: {
      dialogVisible: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        }
      }
    },
    components: {
      CustomDialog: () => import('@/components/customDialog/CustomDialog')
    },
    watch: {
      value(newVal) {
        if (newVal) {
          this.getTableData(1)
        }
      }
    }
  }
 
</script>

<style scoped lang='less'>
  .member-info {
    margin-bottom: 20px;
    padding: 12px 12px;
    width: 406px;
    box-sizing: border-box;
    background: linear-gradient( 96deg, #B6DCFF 0%, #D4EAFF 100%);
    border-radius: 8px 8px 8px 8px;
  }

  .member-info-title {
    display: flex;
    align-items: center;
    font-size: 16px;
  }
  
  .member-info-title span {
    margin-right: 10px;
    font-weight: 600;
    font-size: 14px;
    color: #000;
  }

  .member-info-title span:nth-child(1) {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: #fff;
    text-align: center;
  }

  .member-info-title span:nth-child(1) .el-icon-user-solid {
    color: #BDC9D4;
    font-size: 12px;
    line-height: 18px;
  }

  .member-info-amt {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    padding: 10px;
    background-color: rgba(255, 255, 255, .5);
    border-radius: 6px;
    font-size: 14px;
    color: #667182;
  }

  .member-info-amt-item span {
    display: inline-block;
    vertical-align: middle;
  }

  .member-info-amt-item span.amt {
    margin-left: 6px;
    font-weight: 600;
    font-size: 18px;
  }

  .member-info-amt-item span.amt.current-amt {
    color: #1890FF;
  }

  // 表格单元格样式
  .amt {
    text-align: right;
    font-weight: 600;
  }
  .amt_fail{
    color: #F54A45;
    font-size: 14px;
  }
  .type {
    display: inline-block;
    padding: 2px 8px;
    font-size: 14px;
    border-radius: 2px;
  }
  
  // 交易类型（管理员扣款）
  .type-1 {

  }

  // 交易类型（充值）
  .type1 {
    color: #1890FF;
    background: #E8F4FF;
  }

  // 交易类型（消费）
  .type2 {
    color: #FE8F1F;
    background: #FFF0E1;
  }

  // 交易类型（消费退费）
  .type3 {
    color: #F54A45;
    background: #FEE6E5;
  }

  // 交易类型（充值退费）
  .type4 {
    color: #F54A45;
    background: #FEE6E5;
  }
</style>